import { Pipe, PipeTransform } from '@angular/core';
import { Realisation } from '../classes/realisation';
import { Utils } from '../utils.class';

@Pipe({
    name: 'realisationAfasProjectIdPipe',
    standalone: false,
})
export class RealisationAfasProjectIdPipe implements PipeTransform {
    transform(r: Realisation): string {
        return Utils.realisationAfasProjectId(r);
    }
}
